export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Final2_02.00cc51c6.jpg";